const LK_Edit =({color,width,height})=>{
    return(
        <svg id="Layer_1" fill={color} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
            {/*
            <defs>
                <style>
                    .cls-1 {
                    fill: #fff;
                    stroke-width: 0px;
                    }
                </style>
            </defs> */}
        <path class="cls-1" d="M113.37,22.51L90.86,0l-8.94,8.94L11.61,79.25l3.07,3.07,3.07-3.07,7.7-7.7L81.92,15.08l21.49,21.49L39.24,100.73l-3.07,3.07-24.56-24.56L1.5,116.99l37.74-10.11L106.48,39.64l6.89-6.89c2.83-2.83,2.83-7.41,0-10.23ZM7.64,110.85l6.22-23.21,16.99,16.99-23.21,6.22ZM111.32,28.65l-4.84,4.84-21.49-21.49,5.87-5.87,20.46,20.46c.57.57.57,1.48,0,2.05Z"/>
      </svg>
    );
};

export default LK_Edit;
